export const tw = {
  areaSum: '各戶專有部分面積總合',
  areaPerPerson: '每一專有部分面積',
  ratio: '區分所有權比',
  unit: '平方公尺'
}
export const groupArrItems = (arr, subArrLength = 10) => {
  const tempArr = [...arr]
  const newArr = []
  while (tempArr.length) {
    const subArr = tempArr.splice(0, subArrLength)
    newArr.push(subArr)
  }
  return newArr
}
export default tw
